import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/produtos", label: "Produtos" },
  { to: "/clientes", label: "Clientes" },
  { to: "/codigo-de-etica", label: "Código de Ética" },
  { to: "/contato", label: "Contato" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-surface-line/80 bg-white/85 shadow-[0_1px_0_rgba(15,61,46,0.04)] backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 min-h-[76px] lg:min-h-[92px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex shrink-0 items-center"
          onClick={() => setOpen(false)}
        >
          <img
            src="/images/brand/wellpec-logo-header.png"
            alt="Wellpec"
            className="block h-auto w-[190px] sm:w-[220px] lg:w-[270px] xl:w-[300px]"
          />
        </Link>

        <nav className="hidden xl:flex items-center gap-1 rounded-full border border-surface-line bg-white/70 p-1 shadow-sm">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium transition-all ${
                  isActive
                    ? "bg-brand text-white shadow-sm"
                    : "text-ink hover:bg-surface-alt hover:text-brand"
                }`
              }
              end
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-3">
          <Link
            to="/contato"
            data-testid="header-cta-orcamento"
            className="inline-flex items-center gap-2 rounded-full bg-brand px-5 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:-translate-y-0.5 hover:bg-brand-mid hover:shadow-md"
          >
            Solicitar orçamento
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <button
          type="button"
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden inline-flex h-10 w-10 items-center justify-center rounded-sm border border-surface-line text-ink"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="xl:hidden border-t border-surface-line bg-white"
        >
          <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col gap-2">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end
                data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${
                    isActive ? "text-brand" : "text-ink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contato"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-orcamento"
              className="mt-2 inline-flex items-center justify-center bg-brand text-white font-semibold px-5 py-3 rounded-sm"
            >
              Solicitar orçamento
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
